import React from 'react';
import Chip from '@mui/material/Chip';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { handleValidation } from '../../../utils/formUtils';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@mui/material/Tooltip';

// Notes to use this compenent
// formField value must be an array
// it will save the id of the object in the form data in the array formet
const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const CustomChipInput = (props) => {
  const {
    options,
    defaultValue,
    limitSelected,
    isFilterSelected,
    isCloseOnSelect,
    labelField,
    isClearable,
    isAddNewEnabled,
    onClickAddNew,
    addNewField,
    textFieldLabel,
    textFieldPlaceholder,
    formData,
    setFormData,
    formField,
    setError,
  } = props;

  const onChangeSelected = (values) => {
    const currFields = formData[formField] || {};
    const idArray = values.map((object) => object.id);
    currFields.value = idArray;
    handleValidation(currFields);
    setFormData({ ...formData, [formField]: currFields });
  };
  let textFieldValue = '';

  const getErrorMessage = () => {
    const errorMsgs = [];
    formData[formField]?.validations &&
      formData[formField].validations.forEach((validation) => {
        if (formData[formField].errors[validation]) {
          errorMsgs.push(formData[formField].errors[validation]);
        }
      });
    return errorMsgs.length > 0 ? errorMsgs[0] : null;
  };

  return (
    <div>
      <Autocomplete
        multiple
        value={options.filter((item) => formData[formField]?.value?.includes(item.id))}
        id='tags-standard'
        options={options}
        defaultValue={defaultValue ? defaultValue : []}
        filterSelectedOptions={isFilterSelected ? isFilterSelected : false}
        disableCloseOnSelect={isCloseOnSelect ? !isCloseOnSelect : true}
        disableClearable={isClearable ? !isClearable : true}
        getOptionLabel={(option) => option[labelField]}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <CustomToolTip
              key={index}
              title={option?.customAttributes?.map((item, idx) => (
                <div key={idx}>
                  key: {item.key}, value: {item.value}
                </div>
              ))}
            >
              <Chip
                variant='outlined'
                deleteIcon={<RemoveCircleIcon />}
                label={option.name}
                {...getTagProps({ index })}
              />
            </CustomToolTip>
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant='standard'
            required={
              formData[formField]?.validations &&
              formData[formField].validations.includes('required')
            }
            error={getErrorMessage() ? true : false}
            label={textFieldLabel}
            placeholder={formData[formField]?.value?.length === 0 ? textFieldPlaceholder : ''}
            onChange={(e) => (textFieldValue = e.target.value)}
          />
        )}
        renderOption={(object, option, status) => {
          return (
            <span key={option.id}>
              <CustomToolTip
                title={option?.customAttributes?.map((item, idx) => (
                  <div key={idx}>
                    key: {item.key}, value: {item.value}
                  </div>
                ))}
              >
                <Chip
                  {...object}
                  className='m-1'
                  variant={status.selected ? 'filled' : 'outlined'}
                  label={option[labelField]}
                />
              </CustomToolTip>
            </span>
          );
        }}
        onChange={(event, values, reason) => {
          setError && setError(false);
          if (limitSelected && values.length > limitSelected) {
            values.pop();
          }
          onChangeSelected(values);
        }}
        noOptionsText={
          isAddNewEnabled && (
            <div className='row'>
              <div className='col-md-3'>No result found</div>
              <div
                className='col-md-3 bold-underline'
                style={{
                  fontWeight: 'bold',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  addNewField
                    ? onClickAddNew(addNewField, textFieldValue)
                    : onClickAddNew(textFieldValue);
                }}
              >
                ADD NEW +
              </div>
            </div>
          )
        }
      />
      {getErrorMessage() && (
        <p className='m-0 font-size-small' style={{ color: 'red', fontSize: '12px' }}>
          {getErrorMessage()}
        </p>
      )}
    </div>
  );
};

export default CustomChipInput;
